import * as React from 'react'
import { cn } from '../../lib/utils'

export interface MessageCounterProps extends React.HTMLAttributes<HTMLDivElement> {
	/** Number of unread / pending messages — shown in the badge. */
	count: number
}

/**
 * iOS-style message indicator badge — a red circle with white number inside.
 * Used to highlight unread message counts on deal cards.
 */
const MessageCounter = React.forwardRef<HTMLDivElement, MessageCounterProps>(
	({ className, count, ...props }, ref) => (
		<div
			ref={ref}
			className={cn(
				'flex h-6 w-6 items-center justify-center rounded-full bg-(--color-destructive) text-white',
				'text-xs font-[600] leading-none',
				className
			)}
			{...props}
		>
			{count}
		</div>
	)
)

MessageCounter.displayName = 'MessageCounter'
export { MessageCounter }
